enum ProjectActionTypesEnum {
    SET_PROJECT = "SET_PROJECT",
    SET_PROJECT_MENU = "SET_PROJECT_MENU",
    SET_PROJECT_LIST = "SET_PROJECT_LIST",
    EMPTY_PROJECT = "EMPTY_PROJECT",
}

export default ProjectActionTypesEnum;
